<template>
  <router-view
      :key="$route.fullPath"></router-view>
</template>

<script>
export default {
  name: 'App',
  props: ['themePath',"cursoid","faculdadeid"],
  provide(){
    return{
      initCursoid: this.cursoid,
      initFaculdadeid: this.faculdadeid
    }
  }
}
</script>

<style lang="scss">
@import "./global.scss";
.cursorStyle{
  cursor: move;
}

/*Responsive - iphone*/
@media (max-width: 767px) {
  .row .row {
    margin-right: 0;
    margin-left: 0;
  }
}

@font-face {
  font-family: "Montserrat Bold";
  src: url("./assets/fonts/Montserrat-Bold.otf") format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "Montserrat Light";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Light.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Regular.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat SemiBold";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-SemiBold.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat Thin";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Thin.otf") format("opentype");
}

@font-face {
  font-family: "PT Sans";
  /*src: url("./assets/fonts/PTS55F.ttf");*/
  src: url("./assets/fonts/PTSans.woff2") format('woff2');
}

@font-face {
  font-family: "PT Sans Italic";
  src: url("./assets/fonts/PTSansItalic.woff2") format('woff2');
}

@font-face {
  font-family: "PT Sans Bold Italic";
  /*src: url("./assets/fonts/PTS76F.ttf");*/
  src: url("./assets/fonts/PTSansBoldItalic.woff2") format('woff2');
}

#app .row{
  max-width: 100%;
}

.darkbackground{
  background-color: rgb(135, 206, 250) !important;
}

.defaultcolor.artes-e-humanidades,
.defaultcolor.artes-e-humanidades:after{
  background: $artesHumanidades;
}
.defaultcolor.ciencias-exatas-e-da-engenharia{
  background: $cee;
}
.defaultcolor.ciencias-sociais{
  background: $cs;
}
.defaultcolor.ciencias-da-vida{
  background: $cv;
}
.defaultcolor.escola-superior-de-saude{
  background: $ess;
}
.defaultcolor.escola-superior-de-tecnologia-e-gestao{
  background: $estg;
}

.defaultcolor.artes-e-humanidades:after{
  border-left-color: $artesHumanidades;
}

.defaultcolor.ciencias-exatas-e-da-engenharia:after{
  border-left-color: $cee;
}

.defaultcolor.ciencias-sociais:after{
  border-left-color: $cs;
}

.defaultcolor.ciencias-da-vida::after{
  border-left-color: $cv;
}

.defaultcolor.escola-superior-de-saude:after{
  border-left-color: $ess;
}

.defaultcolor.escola-superior-de-tecnologia-e-gestao:after{
  border-left-color: $estg;
}

.aspaItem.artes-e-humanidades{
  color: $artesHumanidades;
}
.aspaItem.ciencias-exatas-e-da-engenharia{
  color: $cee;
}
.aspaItem.ciencias-sociais{
  color: $cs;
}
.aspaItem.ciencias-da-vida{
  color: $cv;
}
.aspaItem.escola-superior-de-saude{
  color: $ess;
}
.aspaItem.escola-superior-de-tecnologia-e-gestao{
  color: $estg;
}


</style>
